import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src992805003/src/alouette/node_modules/@mui/material/Container/Container.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/outputs/All_Bands.jpg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/outputs/Elevation.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/outputs/True_Colour_Image.jpg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/resolution/10m.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/resolution/30cm.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/resolution/3m.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/resolution/70cm.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/src/assets/img/area1.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/src/assets/img/area2.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/src/assets/img/area3.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/src/assets/img/area4.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src992805003/src/alouette/src/components/productLibrary/productLibrary.tsx");
